import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RouteInfo } from './vertical-sidebar.metadata';
import { ROUTES } from './vertical-menu-items';
import { AuthService } from '../../_services/auth.service';
import { PermissionService } from '../../_services/permission.service';


@Injectable({
    providedIn: 'root'
})
export class VerticalSidebarService {

    public screenWidth = 0;
    public collapseSidebar: boolean = false;
    public fullScreen: boolean = false;

    MENUITEMS: RouteInfo[] = ROUTES;

    items = new BehaviorSubject<RouteInfo[]>([]);

    constructor(
        private authService: AuthService,
        private permissionService: PermissionService
    ) {
        this.filterMenuItems();
        
        // Subscribe to permission changes to refresh menu when permissions are reloaded
        // This handles impersonation mode changes
        this.permissionService.getPermissionsLoadedObservable().subscribe((loaded) => {
            if (loaded) {
                this.filterMenuItems();
            }
        });
    }

    filterMenuItems() {
        const currentUser = this.authService.getCurrentUser();
        const userRoles = currentUser?.roles || [];
        const hasDevRole = userRoles.includes('dev');
        
        // Function to check if a menu item should be visible to the user
        const isMenuItemVisible = (item: RouteInfo): boolean => {
            // If user has dev role, show everything
            if (hasDevRole) return true;

            // Check if any of the user's roles match the menu item's roles
            if (item.roles?.some(role => userRoles.includes(role))) return true;

            // An item may also be revealed by an RBAC permission, for access granted per-role
            // rather than by role name (SPAR-745).
            if (item.permissions?.some(p => this.permissionService.hasPermission(p.resource, p.action))) {
                return true;
            }

            // Neither roles nor permissions specified means only dev users see it
            return false;
        };
        
        // Recursively filter submenu items
        const filterSubmenus = (items: RouteInfo[]): RouteInfo[] => {
            return items.map(item => {
                const newItem = { ...item };
                if (newItem.submenu && newItem.submenu.length > 0) {
                    newItem.submenu = filterSubmenus(newItem.submenu);
                }
                return newItem;
            }).filter(isMenuItemVisible);
        };
        
        // Filter top-level menu items
        const filteredItems = filterSubmenus(this.MENUITEMS);
        
        this.items.next(filteredItems);
    }
}
